export function useIsDev() {
  const config = useRuntimeConfig()
  return computed(() => config.public.env === 'development' || config.public.env === 'test')
}
